import {useCallback, useState} from "react";
import {VoucherTypeResponse} from "../../../../types/cart";
import {getVoucherTypeAsync} from "../../../../store/cart/cartSlice";
import {useAppDispatch} from "../../../../hooks/hooks";
import {UnitVoucherType} from "../../../../types/common";

export function useVoucherTypeGetter() {
    const dispatch = useAppDispatch();
    const [currentVoucherType, setCurrentVoucherType] = useState<UnitVoucherType>()

    const getVoucherType = useCallback(async (productIdx: number) => {
        try {
            const result: VoucherTypeResponse = await dispatch(getVoucherTypeAsync(productIdx)).unwrap();
            setCurrentVoucherType(result.voucherType)
        } catch (error) {
            console.error(error);
        }
    }, [dispatch]);

    return {
        getVoucherType, currentVoucherType
    }
}